import React, { FC, PropsWithChildren } from 'react';
import { ScrollView, View } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { notchTop, scale } from '@components/frame';
import {
  INFO_SCREEN_MARGIN_TOP,
  MACHINES_SCREENS_TOP_BLOCK_HEIGHT_NOT_PHONE,
  SCREEN_PADDING_HORIZONTAL,
  SCREEN_PADDING_VERTICAL,
} from '../../../common/constants/base.constants';
import MachineNameAndStatus from '@v2/pages/machines/common/components/MachineNameAndStatus/MachineNameAndStatus';
import { isPhone } from '@helpers';
import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import CloseButton from '@components/closeButton';
import ColorWrapper, { WithColor } from '@styles/colors';
import PerformanceScreensHeader from './PerformanceScreensHeader';
import PerformanceScreenNet from './PerformanceScreenNet';
import { useHandleBottomSheetActions } from '@v2/pages/common/hooks/useHandleBottomSheetActions';
import { MachineStatusBulletDisplayVariant } from '@v2/pages/machines/common/components/MachineNameAndStatus/types';

interface PerformanceScreensWrapperProps extends WithColor, PropsWithChildren {}

const PerformanceScreensWrapper: FC<PerformanceScreensWrapperProps> = ({ C, children }) => {
  const selectedMachine = useSelector(selectSelectedItem);
  const { closeBottomSheet } = useHandleBottomSheetActions();
  const route = useRoute();

  return (
    <View style={{ flex: 1, backgroundColor: C('Background/Light/System') }}>
      <View
        style={[
          {
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: scale(INFO_SCREEN_MARGIN_TOP),
            marginBottom: scale(SCREEN_PADDING_VERTICAL),
            alignItems: 'center',
          },
          !isPhone && { height: scale(MACHINES_SCREENS_TOP_BLOCK_HEIGHT_NOT_PHONE), paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL) },
          isPhone && { paddingTop: notchTop },
        ]}
      >
        <MachineNameAndStatus
          {...{ selectedItem: selectedMachine, withoutInteractions: true, statusDisplayVariant: MachineStatusBulletDisplayVariant.HIDDEN }}
        />
        <View style={[isPhone && { marginRight: scale(SCREEN_PADDING_HORIZONTAL) }]}>
          <CloseButton C={C} onPress={closeBottomSheet} />
        </View>
      </View>
      <PerformanceScreensHeader />
      <ScrollView showsVerticalScrollIndicator={false}>
        <PerformanceScreenNet screenName={route?.name ?? 'Performance'}>{children}</PerformanceScreenNet>
      </ScrollView>
    </View>
  );
};

export default ColorWrapper(PerformanceScreensWrapper);
